module.exports = __webpack_public_path__ + "img/sierra-leone.780f1ed6.svg";